import React from "react";
import PaymentLinkTable from "../../payment-link-system/PaymentLinkTable";
import { convertStraight } from "../../common-data/Converts";

const ViewLeavesMob = ({ tableData, tbColumns }) => {
  return (
    <>
      <div className="fullWidthFlexCenter overflowAuto separatedTable hideMobile  mt30">
        <PaymentLinkTable tableData={tableData} tableColumns={tbColumns} />
      </div>

      <div className="lead-logs-card-container leave-management-mobile-v only-mobile">
        <div className="all-leads-log mt30">
          {tableData?.length > 0 &&
            tableData.map((staff, index) => {
              return (
                <div className="log-card" key={index}>
                  <div className="all-info">
                    <div
                      className="lead-multi-value-cols"
                      style={{ padding: "20px" }}
                    >
                      <div className="label-value">
                        <span className="label">Leave Date</span>
                        <span className="value">
                          {staff?.leave_date
                            ? convertStraight(staff.leave_date)
                            : "-"}
                        </span>
                      </div>

                      <div className="label-value">
                        <span className="label">approval status</span>
                        <span
                          className="value"
                          style={{
                            background:
                              staff?.approval_status === 1
                                ? "#DCECDC"
                                : staff?.approval_status === 0
                                ? "#FFEDC0"
                                : "#F0E3E3",
                            color:
                              staff?.approval_status === 1
                                ? "#209216"
                                : staff?.approval_status === 0
                                ? "##171717"
                                : "#F13434",
                            padding: "5px",
                            borderRadius: "4px",
                          }}
                        >
                          {staff?.approval_status === 1
                            ? "Approved"
                            : staff?.approval_status === 0
                            ? "Pending"
                            : staff?.approval_status === 2
                            ? "Rejected"
                            : "NA"}
                        </span>
                      </div>

                      <div className="label-value flex-col">
                        <span className="label">Approve/Reject Date</span>
                        <span className="value">
                          {staff?.aprv_rej_date
                            ? convertStraight(staff.aprv_rej_date)
                            : "-"}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </>
  );
};

export default ViewLeavesMob;
